export default __webpack_public_path__ + "static/media/chevrolet.e3411a8a.png";